import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';
import { IFeature } from '../../types/project';
import { Feature } from './components/Feature';
import * as styles from './Features.css';

interface IFeaturesProps {
  features: IFeature[];
}

export const Features: React.FC<IFeaturesProps> = ({ features }) => {
  return (
    <div className={styles['features']}>
      <UIHeading1>О проекте</UIHeading1>
      <div className={styles['list']}>
        {features.map((feature, index) => (
          <Feature key={index} {...feature} />
        ))}
      </div>
    </div>
  );
};
